import { isOk } from './is-ok';

export function replaceNonAlphaNumeric(param: string) {
  if (!isOk(param)) return '';
  return param.replace(/[^0-9a-z ]/gi, '');
}
